/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, time: NonNullable<unknown> }} Station_Work_Event_Speech_TomorrowInputs */

const vi_station_work_event_speech_tomorrow = /** @type {(inputs: Station_Work_Event_Speech_TomorrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nhắc sự kiện ngày mai: ${i?.title}, lúc ${i?.time}`)
};

/**

* @param {Station_Work_Event_Speech_TomorrowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_event_speech_tomorrow = /** @type {((inputs: Station_Work_Event_Speech_TomorrowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Event_Speech_TomorrowInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_event_speech_tomorrow(inputs)
});